const TYPES = {
    CATEGORY: 'category',
    SUB_CATEGORY: 'sub_category',
    NESTED_SUB_CATEGORY: 'nested_sub_category',
    CMS: 'CMS',
    SEARCH_QUERY: 'search_query',
    STATIC_PAGE: 'static_page',
    FILTERED_PAGE: 'filtered_page',
    PLACEHOLDER: 'placeholder',
    MENU_PANEL: 'menu_panel'
};

const PATHS = {
    ROOT: '#!',
    HOMEPAGE: '/'
};

const OTHER_ALIAS = 'Other';

const DEFAULT_VIDEO_SRC = 'https://fiverr-res.cloudinary.com/video/upload/v1564312168/general_assets/categories/videos/fiverr_how_it_works_2.mp4';

const CATEGORIES_MAPPER = {
    'graphics': 'graphics-design',
    'social-marketing': 'online-marketing',
    'writing': 'writing-translation',
    'video': 'video-animation',
    'music': 'music-audio',
    'programming': 'programming-tech',
    'technology': 'programming-tech',
    'tips-advice': 'lifestyle',
    'other': 'lifestyle',
    'fun-bizarre': 'lifestyle',
    'gifts': 'lifestyle',
    'advertising': 'online-marketing'
};

const CATEGORIES_ID_MAPPER = {
    'graphics-design': 3,
    'online-marketing': 2,
    'writing-translation': 5,
    'video-animation': 20,
    'music-audio': 12,
    'programming-tech': 10,
    'lifestyle': 7
};

const PATHFINDER = {
    STORE: 'store',
    SEARCH: 'search_gigs',
    CATEGORY: 'short_category',
    PRO_CATEGORY: 'short_pro_category',
    PRO_SUB_CATEGORY: 'short_pro_sub_category',
    SUB_CATEGORY: 'short_category_sub_category',
    NESTED_SUB_CATEGORY: 'short_category_nested_sub_category',
    SUB_CATEGORY_STATIC_PAGE: 'sub_category_static_page',
    NESTED_SUB_CATEGORY_STATIC_PAGE: 'nested_sub_category_static_page'
};

const EVENTS_MAPPING = {
    PAGE_VIEWED: {
        mixpanel: 'Viewed page'
    },
    PAGE_CHANGE: {
        mixpanel: 'Paginate'
    },
    CLICK: {
        mixpanel: 'Clicked',
        TARGETS: {
            HOW_FIVERR_WORKS_VIDEO: 'How Fiverr Works Video In Category'
        }
    }
};

module.exports = {
    TYPES,
    PATHS,
    DEFAULT_VIDEO_SRC,
    CATEGORIES_MAPPER,
    CATEGORIES_ID_MAPPER,
    PATHFINDER,
    OTHER_ALIAS,
    EVENTS_MAPPING
};
